import create from "zustand";


const useBidStore = create((set) => ({
  bidData: {
    category: "vehicle",
    subCategory: "car",
  },

  addBidData: async (key, data) => {
    try {
      set((state) => ({
        bidData: {
          ...state.bidData, // Keep existing bidData if it exists
          [key]: data, // Use the key to set the new data
        },
      }));
    } catch (error) {
      console.error("addBidData Call error:", error);
      set({
        bidData: null, // Resetting bidData on error
      });
    }
  },
  clearBidData: async () => {
    try {
      set({
        bidData: null, // Resetting bidData on error
      });
    } catch (error) {
      console.error("clearBidData Call error:", error);
      set({
        bidData: null, // Resetting bidData on error
      });
    }
  },

  
  
}));

// Hydrate the store with data from localStorage on creation
const storedBidState = JSON.parse(localStorage.getItem("bidState")) || {};
useBidStore.setState(storedBidState);

// Subscribe to state changes and persist the state to localStorage
useBidStore.subscribe((state) => {
  localStorage.setItem("bidState", JSON.stringify(state));
});

export default useBidStore;